// 信息提示相关
const eleMsgType = {
  success: 'success',
  warning: 'warning',
  error: 'error',
};

const msgContent = {
  SUCCESS: '保存成功',
  WARNING: "请求未通过",
  // error
  SYSTEM: '系统错误，请稍后再试',
};

export const msgCode = {
  SUCCESS: 100,
  WARNING: 200,
  // error
  SYSTEM: -500,
};

// default for admin; vtNotify for front
export function messageHdl({code, msg}) {
  window.UIBlock && UIBlock.unblock();  // admin
  window.UILoader && UILoader.unload();  // front

  let type = eleMsgType.error;
  let dftMsg;

  switch (code) {
    case msgCode.SUCCESS:
      type = eleMsgType.success;
      dftMsg = msgContent.SUCCESS;
      break;
    case msgCode.WARNING:
      type = eleMsgType.warning;
      dftMsg = msgContent.WARNING;
      break;

    // error
    case msgCode.SYSTEM:
      dftMsg = msgContent.SYSTEM;
      break;
    default:
      break
  }
  if (window.vtNotify) {
    vtNotify({
      type: type === eleMsgType.error ? 'danger' : type,
      message: msg ? (msg.message || msg) : dftMsg
    });
    return
  }

  this.$message({
    type: type,
    showClose: true,
    message: msg ? (msg.message || msg) : dftMsg
  });
}
